<template>
  <div>
    <div v-if="ddlCustomGoalList.length">
      <div class="formDiv">
        <div class="Domains" role="tablist" v-for="domain in ddlCustomGoalDomainList">
          <b-card no-body class="mb-2 border-0 border-bottom">
            <b-card-header header-tag="header" class="p-1 box purple border-0" role="tab">
              <K2Row space-between="true" class="p-2">
                <K2Row align="center" v-b-toggle="'my-collapse' + ddlCustomGoalDomainList.indexOf(domain)">
                  <K2Icon color="black" name="add" class="when-open me-2" :font-size="uiVariable.fontSize.md" style="line-height: 16px" />
                  <K2Icon color="black" name="remove" class="when-closed me-2" :font-size="uiVariable.fontSize.md" style="line-height: 16px" />
                  <a> {{ domain }}</a>
                </K2Row>

                <K2Row space-between="true" class="when-open" style="width: 280px">
                  <span style="width: 70px">{{ lang('Term 1') }}</span>
                  <span style="width: 70px">{{ lang('Term 2') }}</span>
                  <!--<span style="width:70px">{{lang("Term 3")}}</span>-->
                  <!--<span style="width:70px">{{lang("Term 4")}}</span>-->
                </K2Row>
              </K2Row>
            </b-card-header>
            <b-collapse v-bind:id="'my-collapse' + ddlCustomGoalDomainList.indexOf(domain)" visible accordion="my-accordion" role="tabpanel">
              <b-card-body>
                <data-tables :data="ddlCustomGoalList.filter(n => n.PlnCusDomain === domain)">
                  <el-table-column v-for="goal in CustomGoalInfo" :prop="goal.prop" :label="goal.label" :key="goal.prop"> </el-table-column>

                  <el-table-column :id="'Term' + i + 'c'" label="" width="70px" v-for="(item, i) in ddlTermCusGoalsList" :key="i">
                    <template slot-scope="scope">
                      <K2Row justify_content="center">
                        <el-checkbox v-model="scope.checked" @change="changeSelectionCus(scope, 0)" :key="i" :checked="item.indexOf(scope.row.PlnCusID) !== -1">
                        </el-checkbox>
                      </K2Row>
                    </template>
                  </el-table-column>

                  <!--<el-table-column id="Term2c" label="" width="70px">-->
                  <!--<template slot-scope="scope">-->
                  <!--<K2Row justify_content="center">-->
                  <!--<el-checkbox v-model="scope.checked"-->
                  <!--@change="changeSelectionCus(scope.row.PlnCusID,2,scope.checked )"-->
                  <!--:key="goalRefresh"-->
                  <!--:checked="ddlTermCusGoalsList[1].indexOf(scope.row.PlnCusID) !== -1"></el-checkbox>-->
                  <!--</K2Row>-->
                  <!--</template>-->
                  <!--</el-table-column>-->

                  <!--<el-table-column id="Term3c" label="" width="70px">-->
                  <!--<template slot-scope="scope"-->
                  <!--class="text-center">-->
                  <!--<K2Row justify_content="center">-->
                  <!--<el-checkbox v-model="scope.checked"-->
                  <!--@change="changeSelectionCus(scope.row.PlnCusID,3,scope.checked)"-->
                  <!--:key="goalRefresh"-->
                  <!--:checked="ddlTermCusGoalsList[2].indexOf(scope.row.PlnCusID) !== -1">-->
                  <!--</el-checkbox>-->
                  <!--</K2Row>-->
                  <!--</template>-->
                  <!--</el-table-column>-->

                  <!--<el-table-column id="Term4c" label="" width="70px">-->
                  <!--<template slot-scope="scope"-->
                  <!--class="text-center">-->
                  <!--<K2Row justify_content="center">-->
                  <!--<el-checkbox v-model="scope.checked"-->
                  <!--@change="changeSelectionCus(scope.row.PlnCusID,3,scope.checked)"-->
                  <!--:key="goalRefresh"-->
                  <!--:checked="ddlTermCusGoalsList[3].indexOf(scope.row.PlnCusID) !== -1">-->
                  <!--</el-checkbox>-->
                  <!--</K2Row>-->
                  <!--</template>-->
                  <!--</el-table-column>-->
                </data-tables>
              </b-card-body>
            </b-collapse>
          </b-card>
        </div>
      </div>
    </div>
    <div class="empty-list_image" v-else>
      <strong>{{ lang('No Custom Goals') }}...</strong>
      <img src="../../../assets/notfound.png" />
    </div>
  </div>
</template>

<script>
import DataSource from '../../../data/datasource'
import K2Icon from '../../../uiComponents/k2Icon/k2MAIcon'
import K2Row from '../../../uiComponents/k2Row/k2Row'
import { lang } from '../../../locale'
import uiVariable from '../../../config/uiVariable'

export default {
  name: 'PlannerCustomGoals',
  props: ['ddlCustomGoalList', 'ddlTermCusGoalsList', 'ddlCustomGoalDomainList', 'changeSelectionCus'],
  components: { K2Row, K2Icon },
  data() {
    return {
      CustomGoalInfo: [
        {
          //   prop: "PlnCusDomain",
          //   label: "Domain"
          // }, {
          //   prop: "PlnCusGoalsITL",
          //   label: "Goal"
          // }, {
          prop: 'PlnCusIndicator',
          label: lang('Indicator'),
        },
      ],
      uiVariable: uiVariable,
      goalRefresh: 0,
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    lang,
    async init() {},
  },
}
</script>
